(ns frontend.view.entity-viewers.events.email-editor
  (:require
   [clojure.string :as string]
   [common.features.plan :as plan]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.actions.email :as email]
   [frontend.conn :as conn]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.entity-viewers.events.editor-utils :as editor-utils]
   [frontend.view.modals.nylas-connect.view :as nylas-connect-view]
   [promesa.core :as p]
   [reagent.core :as r]
   [ui.components.rich-text.view :as rich-text]
   [ui.editors.labelled-input.view :as labelled-input]))

(defn nylas-promo
  []
  [:div.promotion
   [:span
    (loc/tr :email-editor/promo-pre-link)
    [:a
     {:href   (loc/tr :mailto [(loc/tr :mail-address-sales)])
      :target "_blank"}
     (loc/tr :mail-address-sales)]
    (loc/tr :email-editor/promo-post-link)]])

(defn start-nylas-pairing
  [email provider]
  (let [msg {:email    email
             :provider provider}]
    (-> (conn/sendp! :nylas/get-connect-url msg)
        (p/then (fn [resp]
                  (let [url (:body resp)]
                    (js/console.log "REDIRECT URL : " url)
                    (aset js/window.location "href" url)
                    {})))
        (p/catch (fn [_e]
                   (logging/error "Failed to pair nylas"))))))

(defn account-not-connected
  []
  (let [account @session/account
        email (:account/email account)
        state* (r/atom {:email email})]
    (fn []
      (let [email (:email @state*)]
        [:div.promotion
         [:div.flex.flex-col.gap-4.justify-center.items-center
          (loc/tr :email-editor/nylas-not-connected-pre-link)
          [:div.flex.flex-row.flex-1.w-full
           [labelled-input/view
            {:label       (loc/tr :email)
             :data-type   :data.type/text-simple
             :full-width? true
             :value       email
             :on-change   (fn [v]
                            (swap! state* assoc :email v))}]]
          [:div
           {:class "flex gap-2 justify-center items-center"}
           [nylas-connect-view/google-button (partial start-nylas-pairing email)]
           [nylas-connect-view/microsoft-button (partial start-nylas-pairing email)]]
          (loc/tr :email-editor/nylas-not-connected-post-link)]]))))

(defn email-editor
  [{:keys [state entity-id viewed-entity-id on-reset! show-expanded? modal? props on-success-callback!]}]
  (let [viewer-entity (get @session/entities viewed-entity-id)
        {:keys [:primary-button-text :on-submit!
                :email/to :email/cc :email/bcc :email/subject :email/body]}
        props
        entity-type (:entity/type viewer-entity)]
    (if-not (plan/available :feature/nylas-integration @session/tenant @session/role)
      [nylas-promo]
      (if-not (and (:account/nylas-account-id @session/account)
                   (some #{(:account/nylas-status @session/account)}
                         [nil :nylas.status/active]))
        [account-not-connected]
        [editor-utils/editor
         {:state                state
          :always-expanded?     show-expanded?
          :full-width?          true
          :modal?               modal?
          :activity-entity-id   entity-id
          :viewed-entity-id     viewed-entity-id
          :activity-entity-type :email
          :on-success-callback! on-success-callback!
          :on-reset!            on-reset!
          :wysiwyg-attribute    :email/body
          :placeholder          (loc/tr :email-editor-placeholder)
          :init-draft-state!    (fn [update-draft!]
                                  (if (some #{entity-type}
                                            [:entity.type/oppo
                                             :entity.type/company
                                             :entity.type/fund-commitment
                                             :entity.type/fundraising-opportunity
                                             :entity.type/person])
                                    (when viewed-entity-id
                                      (update-draft! :common/related-entities #{viewed-entity-id}))
                                    (update-draft! :common/related-entities #{}))
                                  (if (and (= entity-type :entity.type/person)
                                           (:person/universal-email-address viewer-entity))
                                    (update-draft! :email/to
                                                   (or to
                                                       #{viewed-entity-id}))
                                    (update-draft! :email/to (or to #{})))
                                  (update-draft! :email/subject subject)
                                  (update-draft! :email/cc cc)
                                  (update-draft! :email/bcc bcc)
                                  (update-draft! :email/body body))
          :entity-schema        (if entity-id
                                  (registry/get-schema @session/tenant-schema :existing-email)
                                  (registry/get-schema @session/tenant-schema :entity.type/email))
          :mandatory-field?
          #(when-not entity-id
             (some #{(:attribute %)} [:email/to :email/subject]))
          :on-submit!           (fn [data on-success! on-error!]
                                  (if on-submit!
                                    (on-submit! data on-success! on-error!)
                                    (email/*->send-email
                                     (cu/remove-nil-vals data)
                                     (fn [resp]
                                       (on-success! resp)
                                       (when (fn? on-success-callback!)
                                         (on-success-callback! resp)))
                                     on-error!)))
          :submit-button-disabled?
          (fn [entity-atom]
            (let [no-associations? (empty? (:common/related-entities @entity-atom))
                  no-recipient? (empty? (:email/to @entity-atom))
                  no-subject? (empty? (string/trim (str (:email/subject @entity-atom))))
                  no-body? (rich-text/empty-editor-value? (:email/body @entity-atom))]
              (or no-associations?
                  no-recipient?
                  no-subject?
                  no-body?)))
          :submit-button-text   (or primary-button-text (loc/tr :create-email-button))
          :disabled-button-tooltip-text
          (fn [entity-atom]
            (let [no-recipient? (empty? (:email/to @entity-atom))
                  no-subject? (empty? (string/trim (str (:email/subject @entity-atom))))
                  no-body? (rich-text/empty-editor-value? (:email/body @entity-atom))]
              (cond no-recipient? (loc/tr :email-must-have-recipient)
                    no-subject? (loc/tr :email-must-have-subject)
                    no-body? (loc/tr :email-must-have-body))))}]))))
